import React from 'react';

const AdBanner = () => {
  const domain = window.location.hostname;
  return (
    <div style={{ width: '100%', height: 50, background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', margin: '4px 0' }}>
      <iframe
        src={`/ad.html?d=${domain}`}
        width="320"
        height="50"
        frameBorder="0"
        scrolling="no"
        title="Ad"
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default AdBanner;
